module.exports = __webpack_public_path__ + "img/approveClean.f159b89c.svg";